export function getDisplayNameOrEmail(user) {
    if (!user) return ''
    const {first_name, last_name} = user.profile
    if (last_name || first_name) return `${first_name || ''} ${last_name || ''}`
    return user.username
}
export function getAccountTypeTag(user) {
    if(user?.account_types.length) return new Set(user.account_types.map(x => x.name))
    return ["Student"];
}
